/**
 * 根据页面宽度判断设备类型
 * @param {number} width 可选，默认取当前视口宽度
 * @returns {"pc" | "iPad" | "mobile"}
 */
export function getDeviceTypeByWidth(width) {
  const viewportWidth =
    typeof width === "number" && !Number.isNaN(width)
      ? width
      : typeof window !== "undefined"
      ? window.innerWidth ||
        document.documentElement.clientWidth ||
        document.body.clientWidth
      : 1920;

  // 常用断点：<768 mobile, 768~1024 iPad, >1024 pc
  if (viewportWidth < 768) return "mobile";
  if (viewportWidth <= 1024) return "iPad";
  return "pc";
}




// WEBPACK FOOTER //
// ./src/units/device.js